export default "__VITE_ASSET__ytqS81AS__"